var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29318 0.333374C9.71244 0.333374 9.94552 0.81834 9.68362 1.14572L5.3906 6.512C5.19043 6.7622 4.80989 6.7622 4.60973 6.512L0.316707 1.14572C0.054801 0.818339 0.287889 0.333374 0.707142 0.333374L9.29318 0.333374Z",
    fill: "#B5B5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleDown);
export default __webpack_public_path__ + "static/media/RectangleDown.2b30d114aab2ef94e1a5be05748fc1bd.svg";
export { ForwardRef as ReactComponent };